import { SketchPicker } from 'react-color';
import s from './ColorPicker.module.scss';
import { useState } from 'react';
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg"

type ColorPicker = {
    color?: string
    setColor: (color: string) => void
    show?: boolean
    setShow?: (val: any) => void
}

export const ColorPicker = ({color, setColor }: ColorPicker) => {

    // ### State
    const [show, setShow] = useState(false)

    // ### Effects

    // ### Functions

    // ### Views

    return(
        <div className={s.wrapper}>
            <div className={s.color} style={{background: color || "#000"}} onClick={() => setShow(true)}></div>
            {
                show ? 
                <div className={s.picker}>
                    <div className={s.close_wrapper} onClick={() => setShow(false)}>
                        <CloseIcon/>
                    </div>
                    <SketchPicker 
                        color={color || "#000"} 
                        onChange={(color) => setColor(color.hex)}
                    />
                </div> : null
            }
        </div>
    )
}